import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../auth.service';
import { UserService } from '../../user.service';
import { Observable, map, of, tap } from 'rxjs';
import { UserTypes } from 'src/app/models/userTypes';

@Injectable({
  providedIn: 'root'
})

export class AdminAuthGuard  {
  role:UserTypes = UserTypes.EMA;
  
  constructor(
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean> {
    if (this.authService.getIsEvaluator()) {
      return this.userService.getEvaluatorPermissions(this.role).pipe(map(r => {
        if (!r.admin) {
          this.router.navigateByUrl('access-denied');
          return false;
        } else {       
          return true;
        }
      }));
    } else {
      this.router.navigateByUrl('access-denied');
      return of(false);
    }
  }
}
